module.exports = __webpack_public_path__ + "static/media/artificialintelligencebg11.47cffc15.jpg";